﻿import "../fqsService";
import "../authenticationService"
import { Inject } from "@fiqas/angular-utils";
import { AuthenticationService } from "../authenticationService"
import { AuthorizationService } from "../authorizationService";
import { FqsService } from "../fqsService";
import {
    IIdentityLink, IIdentifiableCollectionProperty, IIdentifiableCollectionPropertyOf, IIdentifiableCollectionOf,
    IIdentifiablePagedCollectionPropertyOf, IIdentifiablePagedCollectionOf
} from "../../interfaces/iFqs"
import { CSharpException, ValidationResult, ParsedResult } from "../../models/base";

export abstract class FiqassistApiServiceBase extends FqsService {
    constructor(
        $q: angular.IQService,
        $http: angular.IHttpService,
        protected authenticationService: AuthenticationService,
        protected authorizationService: AuthorizationService
    ) {
        super($q, $http);
        this.addHttpErrorInterceptor((e, ex) => this.onAuthorizedInterceptor(e, ex), 0);
        this.addHttpErrorInterceptor((e, ex) => this.seqInterceptor(e, ex), 10);
        this.addHttpErrorInterceptor((e, ex) => this.validationErrorInterceptor(e, ex), 20);
        this.addHttpErrorInterceptor((e, ex) => this.csSharpInterceptor(e, ex), 30);
        this.doSetBearer(c => this.authenticationService.AuthenticationSetter(c));
        this.doSetRoles(c => this.authorizationService.RoleHeaderSetter(c));
    }

    private unauthorizedHandlers: ((sender: FiqassistApiServiceBase, url: string) => boolean | void)[] = [];

    public addUnauthorizedHandler(handler: (sender: FiqassistApiServiceBase, url: string) => boolean | void) {
        if (!this.unauthorizedHandlers.some(h => h === handler))
            this.unauthorizedHandlers.push(handler);
    }

    public removeUnauthorizedHandler(handler: (sender: FiqassistApiServiceBase, url: string) => boolean | void) {
        this.unauthorizedHandlers = this.unauthorizedHandlers.filter(h => h !== handler);
    }

    private onAuthorizedInterceptor(response: ng.IHttpPromiseCallbackArg<any>, result: ParsedResult) {
        if (response.status !== 401)
            return;

        return this.onUnauthorized(response.config.url);
    }

    public csSharpInterceptor(response: ng.IHttpPromiseCallbackArg<any>, result: ParsedResult) {
        if (response.status !== 500 || !response.data.Exception || !result)
            return;

        var exception: CSharpException = response.data.Exception;
        if (!exception)
            return;

        result.exception = exception;
        return result;
    }

    public validationErrorInterceptor(response: ng.IHttpPromiseCallbackArg<any>, result: ParsedResult) {
        if (response.status !== 400 || !response.data || !result)
            return;

        var validationResult: ValidationResult = response.data;
        if (!validationResult)
            return;

        result.validation = validationResult;
        return result;
    }

    // add this as fist interceptor
    public seqInterceptor(response: ng.IHttpPromiseCallbackArg<any>, result: ParsedResult) {
        if (!result || !response || !response.headers)
            return;

        var seqRequestId: string = response.headers("X-Correlation-ID");
        if (seqRequestId)
            result.seqrequestid = seqRequestId;
    }

    private onUnauthorized(url: string) {
        var handled = false;
        for (var handler of this.unauthorizedHandlers)
            handled = handler(this, url) === true || handled;
        return handled;
    }

    public GetIIdentifiablePagedCollectionPropertyOf<T>(property: IIdentifiablePagedCollectionPropertyOf<T>, force: boolean = false): ng.IPromise<IIdentifiablePagedCollectionOf<T>> {
        return this.GetIIdentifiableCollectionPropertyOf(property, force);
    }
}
